'use strict';
(function () {
  var _controller = 'newTurn.controller';
  angular.module('pentaApp').controller(_controller, controller);
  controller.$inject = ['$scope', '$q', 'router.resource', 'reservation.resource', 'additionalInformation.resource',
    'queue.resource', '$timeout', 'holiday.resource', 'reservationStats.resource', 'posTable.resource', 'appRate.modal', 'geolocation.factory'];
  function controller($scope, $q, routerResource, reservationResource, additionalInformationResource,
    queueResource, $timeout, holidayResource, reservationStats, posTableResource, appRateModal, geolocationFactory) {
    //// Methods
    $scope.setStep = setStep;
    $scope.nextStep = nextStep;
    $scope.selectQueue = selectQueue;
    $scope.takeTurn = takeTurn;
    $scope.finishReservation = finishReservation;
    $scope.getSelectedQueuesNames = getSelectedQueuesNames;

    //// VARS

    if (profile.enterprise && profile.enterprise.pwaConfig && profile.enterprise.pwaConfig.turnsConfig) {
      $scope.hideQueue = profile.enterprise.pwaConfig.turnsConfig.hideQueue;
      var manualRouter = profile.enterprise.pwaConfig.turnsConfig.manualRouter;
    }
    var queryStringRouter = window.queryStrings && window.queryStrings.router;
    var defaultRouter = appNavigator.topPage.data.currentRouter;
    var allRouters = null;
    var queueTree;
    var holidays = holidayResource.query({ _controller: _controller }, function (data) { data.forEach(function (e) { e.dateString = moment(e.date).utcOffset('0000').format('YYYYMMDD') }); })
    $scope.routers = null;
    $scope.reservation = { inmediate: null };
    $scope.step = null;
    $scope.selectedQueues = []; // Motivos seleccionados . stepMode = 'MULTI-QUEUE-*'.
    $scope.selectedQueue = null; // Motivo seleccionado
    $scope.selectedRouter = null; // Sucursal seleccionada
    $scope.queueTree = null; // Para armar el arbol de motivos
    $scope.additionalInformation = null; // Si el motivo seleccionado requiere completar informacion adicional
    $scope.availability = null; // Para armar el listado de dias para turnos futuros
    $scope.selectedDay = null; // Día actual seleccionado para turno futuro
    $scope.rightNow = null; // Para ocultar cualquier hora que sea anterior a ahora mismo
    $scope.stepMode = profile.enterprise && profile.enterprise.pwaConfig && profile.enterprise.pwaConfig.turnsConfig && profile.enterprise.pwaConfig.turnsConfig.stepMode || null;
    var onClose = appNavigator.topPage.data && appNavigator.topPage.data.onClose;
    var reservationConfig = null; // Configuración de turnos del reouter
    var posTables = null; // En caso que el modo sea calendarizado por locación
    var routerReservations = null; // Para el calculo de disponibilidad
    var additionalInformations = null;
    var steps = ['router', 'queue', 'slots', 'additional', 'reservationType', 'day', 'date', 'comment', 'confirm'];

    $scope.AttachedImgFilesConfig = { multiple: true, accept: "'image/*'", maxSize: '10MB', capture: "'camera'" };
    $scope.AttachedAllFilesConfig = { multiple: true, maxSize: '10MB', capture: "'camera'" };

    var additionalInformationProfile = $scope.$root.profile && $scope.$root.profile.enterprise && $scope.$root.profile.enterprise.additionalInformation || [];

    // Init
    init()

    // WATCHERS
    $scope.$on('$destroy', onDestroy)
    function onDestroy() {
      $scope.$root.abortRequests(_controller);
    }

    // Implementación
    function init() {
      routerResource.query({ _controller: _controller }, function (result) {
        allRouters = result.filter(function (f) { return !f.hidden });
        getDistanceAndSetRoutersDistance()
        $scope.routers = allRouters;
        additionalInformations = additionalInformationResource.query({ targets: 'QUEUE', moment_ne: 'POS', _controller: _controller }, function () {
          switch ($scope.stepMode) {
            case 'MULTI-QUEUE-FIRST':
              steps.unshift('multiQueueFirst');
              queueResource.query({ enterprise: profile.enterprise._id, _controller: _controller }, function (data) {
                data.forEach(function (item) { buildChilds(item, data) });
                queueTree = data.filter(function (f) { return !f.parent });
                $scope.queueTree = queueTree;
                $scope.step = steps[0];
                if (data.length === 1) nextStep(data[0]);
              });
              break;
            default:
              $scope.step = steps[0];
              if (!manualRouter || queryStringRouter) {
                if ($scope.routers.find(function (f) { return f._id === defaultRouter._id })) nextStep(defaultRouter._id); // Elijo por defecto el router si es necesario.
              }
              break;
          }
        });
      });
    }

    function setStep(stepName) {
      $scope.step = stepName;
      // Reseteo los pasos posteriores
      for (var stepIx = steps.indexOf(stepName) + 1; stepIx < steps.length; stepIx++) {
        nextStep(null, steps[stepIx])
      }
    }

    function nextStep(stepValue, stepName) {
      // Procesar el valor actual
      var step = stepName || $scope.step;
      switch (step) {
        case 'router':
          if (stepValue) {
            $scope.selectedRouter = $scope.routers.find(function (f) { return f._id === stepValue });
            if (!$scope.selectedRouter) throw new PentaError('Sucursal inválida')
            $scope.routerStats = reservationStats.get({ router: stepValue });
            $scope.reservation.router = stepValue;
            $scope.selectedQueues.forEach(function (queue) { queue.router = queue.routers && queue.routers.length && queue.routers.find(function (f) { return f._id === $scope.reservation.router }); })
            //$scope.queueTree = null;
          } else {
            $scope.selectedRouter = null;
            $scope.reservation.router = null;
          }
          break;
        case 'queue':
          if (stepValue) {
            $scope.selectedQueue = stepValue;
            $scope.reservation.queue = stepValue && stepValue._id;
          }
          // consultar las mesas si el modo es calendarizado por locación
          if ($scope.selectedQueue && ($scope.selectedQueue.router.mode === 'MODE5' || $scope.selectedQueue.router.mode === 'MODE6' || $scope.selectedQueue.router.mode === 'MODE7'))
            posTables = posTableResource.query({ router: $scope.selectedRouter._id, _controller: _controller });
          break;
        case 'slots':
          if (stepValue) $scope.reservation.slots = stepValue;
          else $scope.askForSlots = false;
          break;
        case 'additional':
          if (stepValue) {
            $scope.reservation.additionalInformation = [];
            //var additionalInformationBackUp = getAdditionalInformationBackup();
            $scope.additionalInformation.forEach(function (f) {
              if (f.type === 'CLIENT-IDENTIFICATION-NUMBER') $scope.reservation.identificationNumber = f.value;
              else if (f.type === 'CLIENT-TELEPHONE') $scope.reservation.telephone = f.value;
              else if (f.type === 'CLIENT-ADDRESS') $scope.reservation.address = f.value;
              //additionalInformationBackUp[f._id] = f.value;
            })
            //appStorage.set("additionalInformationBackUp", JSON.stringify(additionalInformationBackUp));
          } else $scope.reservation.additionalInformation = null;
          break;
        case 'reservationType':
          var queues = $scope.selectedQueue ? [$scope.selectedQueue] : $scope.selectedQueues;
          if (stepValue && !validateReservationType(stepValue, routerReservations, queues))
            return ons.notification.alert({ message: i18next.t('No se puede solicitar mas turnos ') + (stepValue === 'INMEDIATE' ? i18next.t('inmediatos') : i18next.t('futuros')), title: i18next.t('Atención') });
          if (stepValue === 'INMEDIATE') {
            $scope.reservation.inmediate = true;
          } else if (stepValue === 'FUTURE') {
            $scope.reservation.inmediate = false;
          } else {
            $scope.reservation.inmediate = null;
          }
          break;
        case 'day':
          $scope.selectedDay = stepValue;
          break;
        case 'date':
          $scope.reservation.date = stepValue && stepValue.start;
          $scope.reservation.posTable = stepValue && stepValue.posTable;
          break;
        case 'comment':
          $scope.reservation.comment = stepValue;
          break;
      }
      if (stepName) return;
      // Avanzar un paso
      var stepIx = steps.indexOf($scope.step);
      stepIx++;
      $scope.step = steps[stepIx];
      // Inicializar el paso
      switch ($scope.step) {
        case 'router':
          if ($scope.selectedQueues.length) {
            routersAvailableForQueues();
          }
          break;
        case 'queue':
          if (!$scope.selectedQueues.length) {
            queueResource.query({ router: $scope.reservation.router, _controller: _controller }, function (data) {
              $scope.queues = data.filter(function (f) { return f.router.target && !f.router.target.pwaChat });
              data.forEach(function (item) { buildChilds(item, data) });
              $scope.queueTree = data.filter(function (f) { return !f.parent });
              if (data.length === 1) nextStep(data[0]);
            });
          } else { nextStep(); }
          break;
        case 'slots':
          var queues = $scope.selectedQueue ? [$scope.selectedQueue] : $scope.selectedQueues;
          var minAskForSlots = Math.min.apply(null, queues.map(function (m) { return m.askForSlots || 0; }))
          if (minAskForSlots) {
            $scope.askForSlots = true;
            $scope.maxSlots = [];
            for (var i = 1; i <= minAskForSlots; i++) $scope.maxSlots.push(i);
          } else {
            nextStep(1); // Si no requiere cantidad de personas se setea en 1
          }
          break;
        case 'additional':
          var queues = $scope.selectedQueue ? [$scope.selectedQueue] : $scope.selectedQueues;
          $scope.additionalInformation = additionalInformations.filter(function (ai) {
            if (!ai.queues || !ai.queues.length) return true;
            return ai.queues.find(function (f) { return queues.find(function (queue) { return queue._id === f }); })
          })
          if (!$scope.additionalInformation || !$scope.additionalInformation.length) nextStep(false);
          $scope.additionalInformation.forEach(function (f) { setAdditionalInformationFromProfile(f); });
          //applyAdditionalInformationBackUp($scope.additionalInformation);
          break;
        case 'reservationType':
          routerResource.get({ _id: $scope.reservation.router, _controller: _controller }, function (data) {
            reservationConfig = data.reservationConfig
            reservationResource.query({
              router: $scope.reservation.router,
              maxDate: moment().set({ hours: 23, minutes: 59, seconds: 59, milliseconds: 999 }).add(45, 'days').toDate(),
              _controller: _controller
            }, function (data) {
              routerReservations = data;
              $scope.rightNow = new Date();
              $scope.availability = calculateAvailability();
              // ESTO DEBERIA SER MAS INTELIGENTE y verificar ambas queue.
              var queue = $scope.selectedQueue || $scope.selectedQueues[0];
              $scope.disableInmediaTurns = queue.disableInmediaTurns;
              $scope.disableFutureTurns = queue.disableFutureTurns;
              // POR EL MOMENTO NO SE SOPORTA SACAR TURNOS INMEDIATOS PARA EL MULTI TURNO.
              if ($scope.selectedQueues.length) $scope.disableInmediaTurns = true;
              if ($scope.disableInmediaTurns) nextStep('FUTURE');
              else if ($scope.disableFutureTurns) nextStep('INMEDIATE');
            });
          })
          break;
        case 'day':
          if ($scope.reservation.inmediate) nextStep($scope.availability[0]);
          break;
        case 'date':
          if ($scope.reservation.inmediate) nextStep($scope.availability[0].hours[0]);
          break;
        case 'comment':
          if (profile.enterprise.pwaConfig && profile.enterprise.pwaConfig.turnsConfig && profile.enterprise.pwaConfig.turnsConfig.hideComment)
            nextStep('');
          break;
      }
    }

    function buildChilds(parent, nodes) {
      if (typeof parent.nodes === 'undefined') Object.defineProperty(parent, 'nodes', { writable: true });
      parent.nodes = nodes.filter(function (f) { return f.parent === parent._id });
      parent.nodes.forEach(function (node) {
        node._parentArray = parent.nodes;
      })
      parent.nodes.forEach(function (item) { buildChilds(item, nodes) });
    }

    function selectQueue(queue) {
      if (!queue) return
      if (!queue.nodes.length) {
        switch ($scope.stepMode) {
          case 'MULTI-QUEUE-FIRST':
            queue._selected = !queue._selected;
            if (queue._selected) $scope.selectedQueues.push(queue);
            else {
              var index = $scope.selectedQueues.findIndex(function (f) { return f._id === queue._id });
              if (index != -1) $scope.selectedQueues.splice(index, 1);
            }
            break;
          default:
            clearSelectedParents()
            queue._selected = true;
            return nextStep(queue)
        }
      }
      else {
        if (!queue._hide) queue._hide = true;
        else queue._hide = false;
      }
      return queue
    }

    function clearSelectedParents(nextParents) {
      var queues = nextParents || $scope.queues;
      queues.forEach(function (f) {
        if (f._selected === true) f._selected = false;
        if (!f.parent && f.parent !== f._id) f._hide = false;
        if (f.nodes && f.nodes.length) clearSelectedNodes(f.nodes)
      })
    }

    function clearSelectedNodes(nextNodes) {
      nextNodes.forEach(function (f) {
        if (f._selected === true) f._selected = false;
        if (f.nodes && f.nodes.length) clearSelectedParents(f.nodes)
      })
    }

    function calculateAvailability() {
      var thisDay = moment().utcOffset($scope.selectedRouter.utcOffset).set({ hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
      var today = thisDay.clone().set({ hours: 23, minutes: 59, seconds: 59, milliseconds: 999 });
      var tomorrow = today.clone().add(1, 'day');
      var maxDate = thisDay.clone().add(45, 'days');
      var resultDays = [];
      var mainQueue = $scope.selectedQueue || $scope.selectedQueues[0];
      var queues = $scope.selectedQueue ? [$scope.selectedQueue] : $scope.selectedQueues;
      if (!reservationConfig || !reservationConfig.dow) return;
      while (thisDay < maxDate) {
        var dow = thisDay.day()
        var allHours = generateHours(reservationConfig.dow[dow], mainQueue, thisDay);
        var item = {
          date: thisDay.toDate(),
          today: today > thisDay,
          tomorrow: tomorrow > thisDay && today < thisDay,
          hours: []
        }

        item.hours = allHours.filter(function (hour) {
          if (!checkAllModes(mainQueue, hour)) return false;
          var lastHour = hour;
          var lastMeta = mainQueue.router.attendingTime && mainQueue.router.attendingTime.max || 30;
          return queues.every(function (nextReservationQueue, index) {
            if (index === 0) return true;
            var nextReservationDate = moment(lastHour.start).add(lastMeta, "minutes");
            var nextReservationHour = generateHours(reservationConfig.dow[dow], nextReservationQueue, thisDay).find(function (hour) {
              if (nextReservationDate.toDate() >= hour.start && nextReservationDate.toDate() < hour.end) return true;
            });
            if (!nextReservationHour) return false;
            if (!checkAllModes(nextReservationQueue, nextReservationHour)) return false;
            lastHour = nextReservationHour;
            lastMeta = nextReservationQueue.router.attendingTime && nextReservationQueue.router.attendingTime.max || 30;
            return true;
          })
        })
        resultDays.push(item);
        thisDay.add(1, 'day');
      }
      resultDays.forEach(function (day) { day.hours.sort(function (a, b) { return a.start - b.start }); })
      return resultDays.filter(function (f) { return f.hours.length });
    }

    function generateHours(dowIntervals, queue, thisDay) {
      if (!dowIntervals || !dowIntervals.length) return [];
      var includeFrom = moment();
      if (reservationConfig && reservationConfig.disallowReservationsBefore) includeFrom.add(reservationConfig.disallowReservationsBefore, 'milliseconds');
      var hours = [];
      dowIntervals = dowIntervals.filter(function (f) { return !f.queue || f.queue === queue._id });
      // Si tiene al menos una personalizacion en el dia, ignoro todas las personalizaciones globales
      if (dowIntervals.find(function (f) { return f.queue })) dowIntervals = dowIntervals.filter(function (f) { return f.queue });
      dowIntervals.forEach(function (dowInterval) {
        if (dowInterval.dateFrom) {
          var dateFrom = moment(dowInterval.dateFrom).utcOffset($scope.selectedRouter.utcOffset).set({ hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
          if (dateFrom && thisDay.isBefore(dateFrom)) return
        }
        if (dowInterval.dateTo) {
          var dateTo = moment(dowInterval.dateTo).utcOffset($scope.selectedRouter.utcOffset).set({ hours: 23, minutes: 59, seconds: 59, milliseconds: 999 });
          if (dateTo && thisDay.isAfter(dateTo)) return
        }
        dowInterval.usedSlots = 0;
        var dowIntervalStart = thisDay.clone().set({ milliseconds: dowInterval.start });
        var dowIntervalEnd = thisDay.clone().set({ milliseconds: dowInterval.end });
        if (dowIntervalEnd < dowIntervalStart) dowIntervalEnd.add(1, 'day');
        while (dowIntervalStart < dowIntervalEnd) {
          var newItem = {
            start: dowIntervalStart.toDate(),
            end: dowIntervalStart.add(queue.reservationInterval || 30 * 60000, 'milliseconds').toDate(),
            dowInterval: dowInterval
          };
          if (newItem.end < includeFrom) continue;
          if (isHoliday(newItem, $scope.selectedRouter)) continue;
          hours.push(newItem);
        }
      })
      return hours;
    }

    //- retorna true/false si el dia es feriado
    function isHoliday(newItem, router) {
      var dateString = moment(newItem.start).utcOffset("0000").format("YYYYMMDD");
      var holiday = holidays.find(function (holiday) { return holiday.dateString === dateString });
      if (holiday) {
        if (!holiday.routers || !holiday.routers.length) return true;
        if (holiday.routers.find(function (r) { return r === router._id })) return true;
      }
      return false
    }

    function checkAllModes(queue, hour) {
      if (!queue || !queue.router || !hour) return false;
      if (!queue.router.mode) return mode234(queue, hour);
      else if (queue.router.mode === 'MODE2' || queue.router.mode === 'MODE3' || queue.router.mode === 'MODE4') return mode234(queue, hour);
      else if (queue.router.mode === 'MODE5' || queue.router.mode === 'MODE6' || queue.router.mode === 'MODE7') return mode567(queue, hour);
      else if (queue.router.mode === 'MODE8' || queue.router.mode === 'MODE9' || queue.router.mode === 'MODE10') return mode8910(queue, hour);
      else return false
    }

    function mode234(queue, hour) {
      // Modo normal, en base a la cantidad de turnos por segmento
      var usedSlots = 0;
      routerReservations.forEach(function (reservation) {
        if (reservation.queue !== queue._id) return;
        if (typeof reservation.date.getTime !== 'function') reservation.date = new Date(reservation.date);
        var thisDay = moment(hour.start).utcOffset($scope.selectedRouter.utcOffset).set({ hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
        var dowIntervalStart = thisDay.clone().set({ milliseconds: hour.dowInterval.start });
        var dowIntervalEnd = thisDay.clone().set({ milliseconds: hour.dowInterval.end });
        if (dowIntervalEnd < dowIntervalStart) dowIntervalEnd.add(1, 'day');
        if (dowIntervalStart <= reservation.date && reservation.date < dowIntervalEnd) usedSlots++;
      });
      return usedSlots + $scope.reservation.slots <= hour.dowInterval.slots
    }

    function mode567(queue, hour) {
      // Modo calendarizado por locación
      var locationCalendar = posTables.filter(function (f) {
        if (!f.slots) f.slots = 1;
        var match = (!queue.router.area || f.area === queue.router.area._id) && $scope.reservation.slots <= f.slots
        if (match) {
          f.calendar = [];
          return true;
        }
      });
      var meta = queue.router.attendingTime && queue.router.attendingTime.max || 30;

      var absoluteHourStart = moment(hour.start).utcOffset(0, true);
      absoluteHourStart = absoluteHourStart.hours() * 3600000 + absoluteHourStart.minutes() * 60000 + absoluteHourStart.seconds() * 1000 + absoluteHourStart.milliseconds()
      if (absoluteHourStart + meta * 60000 > hour.dowInterval.end) return false; // No puede reservar un turno, si cae fuera del rango configurado
      // EJ: Si configuro un rango de 9 a 12, y la meta de atencion es de 2hs, solo debe habilitarme 9 y 10, si scara a las 11, solo hay una hora
      // para atenderme y no entra...


      routerReservations.forEach(function (reservation) {
        if (reservation.queue !== queue._id || !reservation.posTable) return;
        var location = locationCalendar.find(function (f) { return f._id === reservation.posTable });
        if (!location) return;
        location.calendar.push({
          start: moment(reservation.date),
          end: moment(reservation.date).add(meta, 'minutes')
        })
      })
      var hourEnd = moment(hour.start).add(meta, 'minutes');
      // Lista todas las mesas que no tengas ninguna reserva para el rango actual
      hour.posTable = locationCalendar.filter(function (posTable) {
        return !posTable.calendar.find(function (event) { return event.end > hour.start && event.start < hourEnd })
      })
      hour.posTable.sort(function (a, b) { return a.slots - b.slots });
      hour.posTable = hour.posTable[0];
      return hour.posTable;
    }

    function mode8910(queue, hour) {
      // Modo calendarizado por area

      var areaCalendar = [];
      var meta = queue.router && queue.router.attendingTime && queue.router.attendingTime.max || 30;
      var areaSlots = queue.router && queue.router.area && queue.router.area.slots || 0;

      var absoluteHourStart = moment(hour.start).utcOffset(0, true);
      absoluteHourStart = absoluteHourStart.hours() * 3600000 + absoluteHourStart.minutes() * 60000 + absoluteHourStart.seconds() * 1000 + absoluteHourStart.milliseconds()
      if (absoluteHourStart + meta * 60000 > hour.dowInterval.end) return false; // No puede reservar un turno, si cae fuera del rango configurado
      // EJ: Si configuro un rango de 9 a 12, y la meta de atencion es de 2hs, solo debe habilitarme 9 y 10, si scara a las 11, solo hay una hora
      // para atenderme y no entra...

      routerReservations.forEach(function (reservation) {
        areaCalendar.push({
          start: moment(reservation.date),
          end: moment(reservation.date).add(meta, 'minutes'),
          slots: reservation.slots
        })
      })
      var hourEnd = moment(hour.start).add(meta, 'minutes');
      var calendarOccupiedSlots = 0;
      areaCalendar
        .filter(function (event) {
          return event.end > hour.start && event.start < hourEnd
        })
        .forEach(function (f) { calendarOccupiedSlots += f.slots });
      return calendarOccupiedSlots + $scope.reservation.slots <= areaSlots;
    }

    function takeTurn() {
      var queues = $scope.selectedQueue ? [$scope.selectedQueue] : $scope.selectedQueues;
      var myReservations = routerReservations.filter(function (f) { return f.client });
      if (!reservationUtils.canTakeTurn(myReservations, queues, $scope.reservation.date)) return ons.notification.alert({ message: i18next.t('Usted ya tiene un turno para una fecha demasiado próxima a la seleccionada'), title: i18next.t('Atención') });
      $q.all(queues.map(function (queue, index) {
        var lastQueue = queues[index - 1];
        var request = angular.copy($scope.reservation);
        request.email = $scope.$root.profile.email;
        request.queue = queue._id;
        request.extraData = {};
        request.extraData.externalId = $scope.currentRouter.externalId;
        request.extraData.ticketNow = request.inmediate;
        request.extraData.motive = queue.name;
        request.additionalInformation = buildAdditionalInformation(queue);
        if (lastQueue) request.date = moment(lastQueue._reservationDate).add(lastQueue.router.attendingTime && lastQueue.router.attendingTime.max || 30, "minutes").toDate();
        queue._reservationDate = request.date;
        if (typeof $scope.persistInProfile === 'function') $scope.persistInProfile();
        return reservationResource.doReservation(request, function (result) {
          var split = /(\D*)?(\d*)/.exec(result.serial);
          if (split) {
            request.extraData.letter = result.letter = split[1];
            request.extraData.place = result.place = split[2];
            request.extraData.validationCode = result.validationCode
          }
          reservationResource.doReservation({ _id: result._id, extraData: request.extraData, _controller: _controller, ignoreVeil: true }, Function.prototype);
        }).$promise
      }))
        .then(function (result) {
          finishReservation();
        })
        .catch(function (err) {
          if (err && err.message === '7005') setStep('router');
        })
    }

    function finishReservation() {
      onClose();
      appNavigator.popPage()
      $timeout(function () { appRateModal.open('newTurn') }, 7000)
    }

    function buildAdditionalInformation(queue) {
      var additionalInformation = $scope.additionalInformation.filter(function (ai) {
        if (!ai.queues || !ai.queues.length) return true;
        return ai.queues.find(function (f) { return f === queue._id });
      });
      var withFiles = additionalInformation.filter(function (f) { return f.type === 'FILE' });
      var withoutFiles = additionalInformation.filter(function (f) { return f.type !== 'FILE' });
      withoutFiles.forEach(function (f) { if (f.type && f.type === 'BOOLEAN' && !f.value) f.value = false; })
      if (!withFiles || !withFiles.length) return withoutFiles;
      var newAddInfo = [];
      withFiles.forEach(function (item) {
        var data = [];
        if (item.file && item.file.length) data = makeAdditionalInformation(item);
        else newAddInfo.push(item);
        if (data.length) data.forEach(function (f) { newAddInfo.push(f) });
      });
      return withoutFiles.concat(newAddInfo);
    }

    function makeAdditionalInformation(item) {
      var data = [];
      item.file.forEach(function (file) {
        var info = JSON.parse(JSON.stringify(item));
        info.file = file;
        info._filename = file.name;
        data.push(info);
      })
      return data;
    }

    function validateReservationType(stepValue, myReservations, queues) {
      if (!myReservations || !myReservations.length) return true;
      return queues.every(function (queue) {
        var count = 0;
        if (stepValue === 'INMEDIATE') {
          if (!queue.maxInmediaTurnsPerUser) return true;
          count = myReservations.reduce(function (total, current) {
            if (current.client && current.inmediate && (current.queue === queue._id)) total += 1;
            return total;
          }, 0)
          if (count < queue.maxInmediaTurnsPerUser) return true;
        }
        if (stepValue === 'FUTURE') {
          if (!queue.maxFutureTurnsPerUser) return true;
          count = myReservations.reduce(function (total, current) {
            if (current.client && !current.inmediate && (current.queue === queue._id)) total += 1
            return total;
          }, 0)
          if (count < queue.maxFutureTurnsPerUser) return true;
        }
        return false;
      })
    }

    function getSelectedQueuesNames() {
      var text = '';
      if (!$scope.selectedQueues.length) return '';
      $scope.selectedQueues.forEach(function (f, i) {
        if (f.name) text += f.name + ($scope.selectedQueues.length > 1 && $scope.selectedQueues.length !== (i + 1) ? ', ' : '');
      })
      return text
    }

    function routersAvailableForQueues() {
      $scope.routers = allRouters;
      $scope.routers = $scope.routers.filter(function (router) {
        return $scope.selectedQueues.every(function (f) { return f.routers.find(function (r) { return r._id === router._id }) });
      })
    }

    function getDistanceAndSetRoutersDistance() {
      $scope.routersDistanceReady = false;
      // Esto es una protección por si falla la obtención de la distancia.
      $timeout(function () { $scope.routersDistanceReady = true; }, 8000)
      geolocationFactory.getCurrentPosition(setRoutersDistance,
        function () {
          geolocationFactory.estimatePosition()
            .then(setRoutersDistance)
            .catch(function () {
              $scope.routersDistanceReady = true;
              if (!$scope.$$phase) $scope.$apply();
            })
          $scope.badPrecision = true;
        });
    }

    function setRoutersDistance(position) {
      if (!position || !position.latitude || !position.longitude) return
      var routersFiltered = allRouters.filter(function (router) {
        if (!router.geolocalization || !router.geolocalization.coordinates) return;
        if (!router.geolocalization.coordinates[0] || !router.geolocalization.coordinates[1]) return;
        var lat = router.geolocalization.coordinates[0];
        var lng = router.geolocalization.coordinates[1];
        if (!(lat > -90 && lat < 90) || !(lng > -180 && lng < 180)) return;
        return true;
      })
      routersFiltered.forEach(function (router) {
        var routerPosition = router.geolocalization.coordinates;
        router._distanceToUser = geolocationFactory.getDistance(routerPosition[0], routerPosition[1], position.latitude, position.longitude)
      });
      $scope.routersDistanceReady = true;
      if (!$scope.$$phase) $scope.$apply();
    }

    function getAdditionalInformationBackup() {
      var additionalInformationBackUp = appStorage.get("additionalInformationBackUp");
      if (additionalInformationBackUp) {
        try { additionalInformationBackUp = JSON.parse(additionalInformationBackUp); } catch (error) { additionalInformationBackUp = {}; }
      } else additionalInformationBackUp = {};
      return additionalInformationBackUp;
    }

    function applyAdditionalInformationBackUp(additionalInformations) {
      if (!additionalInformations || !additionalInformations.length) return;
      var additionalInformationBackUp = getAdditionalInformationBackup();
      additionalInformations.forEach(function (f) {
        f.value = additionalInformationBackUp[f._id];
      })
    }

    function setAdditionalInformationFromProfile(additionalInformation) {
      if (!additionalInformation || !additionalInformation._id) return
      var aiProfile = additionalInformationProfile.find(function (f) { return f._id === additionalInformation._id });
      if (aiProfile) additionalInformation.value = aiProfile.value;
    }
  }
})();

